module.exports = __webpack_public_path__ + "static/media/icons-hb-delivery.0cd727ef.svg";